import { 
  GetAllPlans,
  GetPlan,
  CreatePlan,
  UpdatePlan,
  DeletePlan,
  UpdatePlanOptions,
  AddConfRoom,
  UpdateConfRoom,
  RemoveConfRoom,
  GetSubscribers,
  GetPricesList,
  UpdatePricesList
} from '@/api/plans';

// eslint-disable-next-line import/no-cycle

export const getPlans = ({ commit, state, dispatch }, showHidden) => dispatch('CheckAuth', null, {root: true})
  .then(() => new Promise((resolve, reject) => {
    GetAllPlans(showHidden)
      .then((resp) => {
        commit('SAVE_PLANS', resp.plans);
        resolve(resp.plans);
      });
  }))
  .catch((e) => {
    console.log('err on getPlans', e);
  });

export const getPlan = ({ dispatch }, id) => dispatch('CheckAuth', null, {root: true})
  .then(() => GetPlan(id)
    .then(res => {
      return res.plan;
    }))
  .catch((e) => {
    console.log('err on getPlan', e);
  });

export const createPlan = ({ dispatch, commit }, params) => dispatch('CheckAuth', null, {root: true})
  .then(() => CreatePlan(params)
    .then(res => {
      commit('ADD_PLAN', res.plan);
      return res;
    }))
    .catch((e) => {
      console.log('err on createPlan', e);
    });

export const updatePlan = ({ dispatch, commit }, params) => dispatch('CheckAuth', null, {root: true})
  .then(() => UpdatePlan(params)
    .then(res => {
      commit('UPDATE_PLAN', res.plan);
      return res;
    }))
    .catch((e) => {
      console.log('err on updatePlan', e);
    });

export const deletePlan = ({ dispatch, commit }, id) => dispatch('CheckAuth', null, {root: true})
.then(() => DeletePlan(id)
  .then(res => {
    commit('REMOVE_PLAN', id);
    return res;
  }))
  .catch((e) => {
    return new Promise((resolve, reject) => {
      reject(e);
    })
  });
  
export const updatePlanFeatures = ({ commit, dispatch }, params) => dispatch('CheckAuth', null, {root: true})
  .then(() => UpdatePlanOptions(params)
    .then(res => {
      commit('UPDATE_PLAN', res.plan);
      return res;
    }))
  .catch((e) => {
    return new Promise((resolve, reject) => {
      reject(e);
    })
  });

export const getPlanSubscribers = ({ commit, dispatch }, id) => dispatch('CheckAuth', null, {root: true})
  .then(() => GetSubscribers(id)
    .then(res => {
      return res;
    }))
  .catch((e) => {
    console.log('err on getPlanSubscribers', e);
  });

export const addConfRoom = ({ commit, dispatch}, params) => dispatch('CheckAuth', null, {root: true})
  .then(() => AddConfRoom(params)
    .then(res => {
      commit('ADD_CONF_ROOM', {res, params});
      return res;
    }))
  .catch((e) => {
    console.log('err on addConfRoom', e);
  });

export const updateConfRoom = ({ commit, dispatch}, params) => dispatch('CheckAuth', null, {root: true})
  .then(() => UpdateConfRoom(params)
    .then(res => {
      commit('UPDATE_CONF_ROOM', {res, params});
      return res;
    }))
  .catch((e) => {
    console.log('err on updateConfRoom', e);
  });

export const removeConfRoom = ({ commit, dispatch}, params) => dispatch('CheckAuth', null, {root: true})
  .then(() => RemoveConfRoom(params)
    .then(res => {
      commit('REMOVE_CONF_ROOM', params);
      return res;
    }))
  .catch((e) => {
    console.log('err on removeConfRoom', e);
  });

// Lvl1 mail settings (no plan)
export const getPricesList = ({dispatch}) => dispatch('CheckAuth', null, {root: true})
  .then(() => GetPricesList()
    .then(res => {
      return res;
    })
    .catch(e => new Promise((resolve, reject) => {
        reject(e);
    }))
  )

export const updatePricesList = ({dispatch}, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => UpdatePricesList(data)
    .then(res => {
      return res;
    })
    .catch(e => new Promise((resolve, reject) => {
        reject(e);
    }))
  )
